import { render, staticRenderFns } from "./DocAffertDocument.vue?vue&type=template&id=8d15989a&"
import script from "./DocAffertDocument.vue?vue&type=script&lang=js&"
export * from "./DocAffertDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports